<template>
  <div>
    <!--头部开始 -->
    <top-part></top-part>

    <!-- 头部结束 -->
    <div v-show="!test" class="my-content ques-content-box">
      <div class="notice-box" v-if="needReanswer == 'true'">
        问卷答题记录管理员已删除，请重新答题
      </div>
      <!-- 答卷时的进度条 -->
      <el-progress
        v-show="questionPreviewList.isProgress == 1"
        color="#2cc7c5"
        :text-inside="true"
        :stroke-width="18"
        :percentage="answerPercentage"
        status="success"
      ></el-progress>
      <div
        :class="[
          'main-container',
          questionPreviewList.isProgress == 1
            ? 'main-container-progress'
            : 'main-container-noProgress',
        ]"
      >
        <!-- 问卷前置说明 -->
        <div v-show="questionPreviewList.startText" class="question-preText">
          {{ questionPreviewList.startText }}
        </div>
        <!-- 问卷题目列表 -->
        <div class="question-content">
          <div
            v-for="qSubject in questionPreviewList.questions"
            :key="qSubject.id"
            class="preview-container"
            :id="`question-${qSubject.id}`"
          >
            <!-- questionPreviewList.answeredId表示当前问卷是否已做答，-1表示未答 -->
            <component
              :previewOption="qSubject"
              :list="questionPreviewList"
              :index="qSubject.numIndex"
              ref="child"
              :isAnswered="btnDisabled()"
              :isQuestionNum="questionPreviewList.isQuestionNum == 1"
              :is="questionPreview[qSubject.type]"
              :isChecks="isCheck"
            />
          </div>
          <div class="my_flex" v-if="forceSign == 1">
            <div class="sign_title">签名</div>
            <div v-if="signatureImg" class="resign">
              <img class="sign-img" :src="signatureImg" />
              <span
                @click="showPopup"
                class="resign-txt"
                v-if="answeredId == -1"
                >重新签名</span
              >
            </div>
            <div v-else class="signature_edit" @click="showPopup">
              <div>
                <img src="@/images/edit.png" alt />
                <span class="no_singature">签名</span>
              </div>
            </div>
          </div>
          <!-- 签名展示 结束-->
        </div>
      </div>

      <div
        class="submit-container"
        v-show="
          questionPreviewList.questions &&
          questionPreviewList.questions.length !== 0
        "
      >
        <el-button
          v-loading="loading"
          type="primary"
          style="width: 80%"
          :class="flag ? '' : 'buttons'"
          @click="submitQuestinAnswer"
          :disabled="!flag || answeredId != -1"
          >提交</el-button
        >
      </div>
    </div>

    <!-- 签名弹出框 -->
    <div
      v-show="test"
      class="sign"
      style="position: fixed; top: 0; z-index: 9999; bottom: 0"
    >
      <signature @closePop="closePop" @saveImg="complete"></signature>
    </div>
    <!-- 签名弹出框结束 -->
  </div>
</template>
<script>
import PreviewMatrix from "./components/previewMatrix";
import PreviewFillBlank from "./components/PreviewFillBlank";
import PreviewRadio from "./components/PreviewRadio";
import PreviewCheckBox from "./components/PreviewCheckBox";
import PreviewSelect from "./components/PreviewSelect";
import PreviewMulSelect from "./components/PreviewMulSelect";
import PreviewSort from "./components/PreviewSort";
import PreviewParagraph from "./components/PreviewParagraph";
import axiosConter from "../../axios/centralControl";
import moment from "moment";
import checkCentralControl from "./check/checkCentralControl";
import signature from "../../components/signature.vue";
import { toast } from "@/common/api/api.js";
import topPart from "../../components/topPart";
import notice from "./notice/notice.js";
export default {
  components: {
    PreviewMatrix,
    PreviewFillBlank,
    PreviewRadio,
    PreviewCheckBox,
    PreviewSelect,
    PreviewMulSelect,
    PreviewSort,
    PreviewParagraph,
    signature,
    topPart,
  },
  data() {
    return {
      loading: false,
      flag: true,
      questionPreview: {
        radio: "PreviewRadio",
        checkbox: "PreviewCheckBox",
        input: "PreviewFillBlank",
        array: "PreviewMatrix",
        paragraph: "PreviewParagraph",
        sort: "PreviewSort",
        select: "PreviewSelect",
        nd_select: "PreviewMulSelect",
      },
      questionPreviewList: {}, //当前问卷的题目列表
      openTime: "",
      answerPercentageStep: 0, //进度条的步长
      answerPercentage: 0, //进度条的进度
      questionSubjectPercentage: {},
      questionId: "",
      test: "", //签名组件
      currentParams: {}, //提交参数
      signatureImg: "", //签名图片
      forceSign: "", //是否需要签名
      minQuestionList: "",
      maxQuestionList: "",
      answerRecordsList: "",
      checkData: "",
      isCheck: false,
      flags: false,
      needReanswer: "", //是否需要重新答题
      isScore: false
    };
  },
  beforeRouteLeave(to, from, next) {
    localStorage.removeItem("currentQuestionItem");
    next();
  },
  //销毁观察者
  destroyed() {
    notice.offBrother("questionnaireObserver");
  },
  created() {
    //注册观察者//
    notice.onBrother("questionnaireObserver", (data) => {
      //提交按钮校验触发
      this.submitCheck();
    });
    //观察者注册结束
    // const currentQuestionItem = JSON.parse(
    //   localStorage.getItem("currentQuestionItem")
    // );
    // document.title =
    //   this.$route.query.question_name || currentQuestionItem.question_name;
    // this.answeredId = this.$route.query.answeredId || currentQuestionItem.answeredId;
    // console.log(this.answeredId, "answeredId");
  },
  mounted() {
    const questionId = this.getQueryString("id");
    this.questionId = questionId
      ? questionId
      : localStorage.getItem("currentQuestionId");
    localStorage.getItem("currentQuestionId", this.questionId);
    this.getCurrentQuestionAllSubject(this.questionId);
    this.openTime = moment(this.centralControl.utils.obtainEast8Date()).format(
      "YYYY-MM-DD HH:mm:ss"
    );
  },
  methods: {
    //校验 提交 按钮校验
    submitCheck() {
      const childList = this.$refs.child;
      let answerRecords = [];
      let isBreak = [];
      for (let index = 0; index < childList.length; index++) {
        const item = childList[index];
        // 调用子组件的doValided方法进行题目验证，子组件必须有doValided和checkValided方法，详见子组件
        const isValided = item.doValidedFlag();
        if (item.$vnode.tag.indexOf("Paragraph") < 0) {
          if (isValided) {
            isBreak.push(index);
          } else {
            answerRecords = answerRecords.concat(item.answerVal);
          }
        }
      }
      // console.log("观察者执行++", isBreak, answerRecords);
      this.checkData = answerRecords;
      // var flagCount = false
      //  if (isBreak.length === 0) {
      //   //当前问卷题目均为非必答题时，阻止未做答任何题目点击提交
      //   if (answerRecords.length !== 0) {
      //      flagCount = true;
      //   }
      //  }
      this.flag = true;
    },
    // 是否不可点击
    btnDisabled() {
      const { answeredId, statusRun, status } = this.questionPreviewList;
      // statusRun==0 暂停 status=='recovery'完成
      return answeredId != -1 || statusRun == 0 || status == "recovery";
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },

    // 获取当前问卷的必填题目，使用必填题目个数获取单个题目的进度条步长
    getAnswerPercentageStep() {
      let questionSubjectLength = 0;
      this.questionPreviewList.questions.forEach((qSubject) => {
        qSubject.isMust === 1 && questionSubjectLength++;
      });
      this.answerPercentageStep = Math.ceil(100 / questionSubjectLength);
    },
    /**
     * 设置进度条的总进度
     * @questionSubjectId: 题目id
     * @isAnswer: true:题目已做答添加到对象 false：题目未做答从对象remove
     */
    setAnswerPercentage(questionSubjectId, isAnswer) {
      if (this.questionPreviewList.isProgress != 1) {
        return;
      }
      this.answerPercentage = 0;
      if (isAnswer) {
        this.questionSubjectPercentage[questionSubjectId] =
          this.answerPercentageStep;
      } else {
        this.questionSubjectPercentage.hasOwnProperty(questionSubjectId) &&
          delete this.questionSubjectPercentage[questionSubjectId];
      }
      for (const key in this.questionSubjectPercentage) {
        if (this.questionSubjectPercentage.hasOwnProperty(key)) {
          const element = this.questionSubjectPercentage[key];
          this.answerPercentage =
            this.answerPercentage + element > 100
              ? 100
              : this.answerPercentage + element;
        }
      }
    },
    getCurrentQuestionAllSubject(id) {
      const params = { id, isWx: 1 };
      this.centralControl.axios.centralControl(
        "getCurrentQuestionAllSubject",
        (data) => {
          // alert("data.code"+data.code);
          // alert("data.message"+data.message);
          if (data.code == 200) {
            this.needReanswer = data.data.needReanswer;
            this.answeredId = data.data.answeredId;
            document.title = data.data.name;
            const questionList = data.data.questions;
            this.maxQuestionList = data.data.questions.maxSelect; //最多可选择的选项
            this.minQuestionList = data.data.questions.minSelect; //最少可选择的选项
            const previewData = [];
            let numIndex = 0;
            this.forceSign = data.data.forceSign;
            this.signatureImg = data.data.signature;
            for (let index = 0; index < questionList.length; index++) {
              const item = questionList[index];
              if (item.type === "paragraph") {
                previewData.push({ ...item, numIndex: null });
              } else {
                numIndex++;
                previewData.push({ ...item, numIndex });
              }
            }
            this.questionPreviewList = { ...data.data, questions: previewData };
            // 问卷暂停 未答人员answeredId=-1   问卷已暂停statusRun 0
            // answeredId != -1  -1没答  不是-1就是答了
            // 问卷结束 未答人员answeredId=-1   问卷已结束status=recovery
            const { answeredId, statusRun, status } = this.questionPreviewList;
            if (answeredId == -1 && statusRun == 0)
              return toast(this, `问卷已暂停`, "error");
            if (answeredId == -1 && status == "recovery")
              return toast(this, `问卷已结束`, "error");
            this.getAnswerPercentageStep();

            //判断问卷是否设置分数
            if(data.data.score || data.data.score>0){
              this.isScore = true;
            }

          } else {
            this.$message.error(data.message);
          }
        },
        params
      );
    },
    scrollToElement(elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        // 先快速滚动到大致位置
        element.scrollIntoView({ behavior: "auto", block: "nearest" });
        // 然后使用平滑滚动微调位置
        setTimeout(() => {
          const elementTop = element.getBoundingClientRect().top;
          const offset = 20; // 额外的偏移量
          window.scrollBy({
            top: elementTop - offset,
            behavior: "smooth",
          });
        }, 50);
      }
    },
    //提交答题结果
    submitQuestinAnswer() {
      const childList = this.$refs.child;
      let answerRecords = [];
      let isBreak = [];
      let invalidQuestions = []; // 存储未通过校验的题目索引
      for (let index = 0; index < childList.length; index++) {
        const item = childList[index];
        // 调用子组件的doValided方法进行题目验证，子组件必须有doValided和checkValided方法，详见子组件
        const isValided = item.doValided();
        if (item.$vnode.tag.indexOf("Paragraph") < 0) {
          if (isValided) {
            isBreak.push(index);
            invalidQuestions.push(index); // 收集未通过的题目索引
          } else {
            answerRecords = answerRecords.concat(item.answerVal);
          }
        }
      }
      if (invalidQuestions.length > 0) {
        const firstInvalidIndex = invalidQuestions[0];
        const firstInvalidQuestion =
          this.questionPreviewList.questions[firstInvalidIndex];
        if (firstInvalidQuestion) {
          this.$nextTick(() => {
            this.scrollToElement(`question-${firstInvalidQuestion.id}`);
          });
        }
        return;
      }
      //校验校验多选项答题规范
      let queList = this.questionPreviewList.questions;
      let invalidMultiQuestions = [];
      this.flags = false;
      if (queList && queList.length) {
        for (let index = 0; index < queList.length; index++) {
          const item = queList[index];
          this.$set(item, "checksed", false); // 重置校验状态
          if (item.type === "checkbox") {
            if (item.lengthArr && item.lengthArr.length) {
              const selectedCount = item.lengthArr.length;
              const isInvalid =
                item.maxSelect !== item.minSelect
                  ? selectedCount > item.maxSelect ||
                    selectedCount < item.minSelect
                  : selectedCount !== item.maxSelect;

              if (isInvalid) {
                invalidMultiQuestions.push(index);
                this.isCheck = true;
                this.$set(item, "checksed", true);
              }
            }
          }
        }
      }
      // 如果有多选题不符合规范，滚动到第一个不符合规范的多选题
      if (invalidMultiQuestions.length > 0) {
        const firstInvalidIndex = invalidMultiQuestions[0];
        const firstInvalidQuestion =
          this.questionPreviewList.questions[firstInvalidIndex];
        if (firstInvalidQuestion) {
          this.$nextTick(() => {
            this.scrollToElement(`question-${firstInvalidQuestion.id}`);
          });
        }
        return;
      }
      //对单个题目进行校验
      // console.log(this.minQuestionList,this.maxQuestionList)
      // if(answerRecords.length<this.minQuestionList || answerRecords.length>this.maxQuestionList){
      //   this.$message.error("您未作答！请您作答任意一个题均可");
      //   return;
      // }

      //校验（题目做大是否符合规范）
      // checkCentralControl.checkMainFunction(this.questionPreviewList.questions,answerRecords);

      if (isBreak.length === 0) {
        //当前问卷题目均为非必答题时，阻止未做答任何题目点击提交
        if (answerRecords.length === 0) {
          this.$message.error("您未作答！请您作答任意一个题均可");
          return;
        }
        const loginInfo = localStorage.getItem("loginInfo");
        const currentLoginInfo = loginInfo ? JSON.parse(loginInfo) : {};
        const params = {
          pvqId: this.questionId, //当前问卷ID
          openTime: this.openTime, //问卷开始做答的时间
          subTime: moment(this.centralControl.utils.obtainEast8Date()).format(
            "YYYY-MM-DD HH:mm:ss"
          ), //问卷做答结束的时间
          subName: currentLoginInfo.name, //当前答卷人
          deviceType: "phone",
          // userId: "", //当前答卷人的ID
          answerRecords: JSON.stringify(answerRecords),
        };
        if (this.signatureImg) params.signature = this.signatureImg;
        if (this.forceSign == 1 && !this.signatureImg)
          return toast(this, `请先签名`, "error");
        this.currentParams = params;
        // this.saveApi();
        this.getQueryScore();
      }
    },
    getQueryScore() {
      let params = this.currentParams;
      this.loading = true;
      this.centralControl.axios.centralControl(
        "getQuestionScore",
        (data) => {
          this.test = false;
          if (data.code == 200) {
            this.scoreAlert(data.data);
            // this.showQuestionEndText();
          } else {
            this.$message.error(data.message);
          }
          this.loading = false;
        },
        params
      );
    },
    scoreAlert(data) {
      const _this = this;
      _this
        .$createDialog({
          type: "confirm", // 使用 confirm 类型来包含确定和取消按钮
          title: _this.questionPreviewList.name, // 弹窗标题取试题名称
          content: _this.isScore ? `本次问卷得分${data.totalScore}，答对${data.rightCount}，答错${data.wrongCount}` : '', // 弹窗内容为接口返回的内容
          confirmBtn: {
            text: "继续提交",
            active: true,
            href: "javascript:;",
          },
          cancelBtn: {
            text: "重新答题",
            active: false,
            href: "javascript:;",
          },
          onConfirm: () => {
            this.saveApi();
            // 这里可以添加继续提交的逻辑
          },
          onCancel: () => {
            // “重新答题”按钮的回调函数
            _this.$message({
              type: "info",
              message: "已选择重新答题",
            });
            // 这里可以添加重新答题的逻辑，例如重置答题状态
            // _this.resetQuestion();
            _this.$router.go(0); // 刷新当前页面
          },
        })
        .show();
    },
    resetQuestion() {
      // 重置当前组件的状态
      this.answerRecordsList = [];
      this.answerPercentage = 0;
      this.questionSubjectPercentage = {};
      this.signatureImg = ""; // 清空签名图片
      this.isCheck = false; // 重置多选题校验状态

      // 其他可能需要重置的状态
      this.checkData = [];
      this.flags = false;
      // 重置子组件的状态
      const childList = this.$refs.child;
      if (childList && childList.length > 0) {
        for (let index = 0; index < childList.length; index++) {
          const item = childList[index];
          if (item.reset) {
            item.reset(); // 调用子组件的 reset 方法
          }
        }
      }
    },
    // 问卷保存接口 signatureImg
    saveApi() {
      let params = this.currentParams;
      this.loading = true;
      this.centralControl.axios.centralControl(
        "saveQuestionAnswer",
        (data) => {
          this.test = false;
          if (data.code == 200) {
            this.showQuestionEndText();
          } else {
            this.$message.error(data.message);
          }
          this.loading = false;
        },
        params
      );
    },
    showAlert() {
      const _this = this;
      this.$createDialog(
        {
          type: "alert",
          content: "答卷提交成功，感谢您的支持！",
          onConfirm: (e, promptValue) => {
            _this.$router.go(-1);
          },
        },
        (createElement) => {
          return [
            createElement(
              "div",
              {
                class: {
                  "endText-title": true,
                },
                slot: "title",
              },
              [createElement("p", _this.questionPreviewList.name)]
            ),
          ];
        }
      ).show();
    },
    //答题完毕时的弹出框，用户显示后置说明
    showQuestionEndText() {
      const _this = this;
      //没有后置说明时弹框
      if (_this.questionPreviewList.endText.length === 0) {
        _this.showAlert();
        return;
      }
      this.$createDialog(
        {
          type: "alert",
          onConfirm: (e, promptValue) => {
            _this.$router.go(-1);
          },
        },
        (createElement) => {
          return [
            createElement(
              "div",
              {
                class: {
                  "endText-title": true,
                },
                slot: "title",
              },
              [createElement("p", _this.questionPreviewList.name)]
            ),
            createElement(
              "div",
              {
                class: {
                  "endText-content": true,
                },
                slot: "content",
              },
              _this.questionPreviewList.endText
            ),
          ];
        }
      ).show();
    },
    showPopup() {
      this.test = true;
    },
    closePop() {
      this.test = false;
    },
    complete(data) {
      if (!data) return this.$message.error("保存签名失败");
      this.closePop();
      this.signatureImg = data;
      // this.saveApi({ signature: data });
    },
  },
};
</script>

<style lang="stylus" type="stylesheet/stylus">
.buttons {
  background-color: #cccccc !important;
  border-color: #cccccc !important;
}

.notice-box {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  padding: 0 10px;
  background: #fafaf1;
  color: red;
}

.ques-content-box {
  // bottom: 50px;
  background: #fff !important;

  .resign-txt {
    font-style: normal;
    margin: auto 0;
  }

  .resign {
    flex: 1;
    text-align: center;
    display: flex;
  }

  .sign-img {
    width: 60px;
    height: 60px;
    margin: auto;
    transform: rotate(90deg);
  }

  .my_flex {
    display: flex;
    align-items: center;
    background: #FFF;
    padding: 16px;
    justify-content: space-between;

    .sign_title {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(53, 53, 53, 1);
    }
  }

  .signature_edit {
    width: 252px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(41, 190, 188, 1);

    .no_singature {
      display: inline-block;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(41, 190, 188, 1);
      line-height: 22px;
    }

    img {
      width: 16px;
      margin-right: 4px;
    }
  }
}

.my_signature {
  background: #FFF;
  padding: 0px 20px;
  text-align: center;

  img {
    // padding:20px;
    width: 100px;
    transform: rotate(90deg);
  }
}

// 后置说明的标题
.endText-title {
  padding: 10px 20px;
  font-size: 18px;
  text-align: justify;
  text-justify: unset;
  line-height: normal;
}

.endText-content {
  padding: 0 20px;
  font-size: 14px;
  text-align: justify;
  text-justify: unset;
  line-height: normal;
  height: 180px;
  overflow-y: auto;
}

// .main-container-progress {
// height: calc(100vh - 68px);
// }

// .main-container-noProgress {
// height: calc(100vh - 52px);
// }
.main-container {
  background-color: #fff;
  overflow-y: auto;

  .question-content {
    background-color: #f0f0f4;
  }

  .preview-container {
    background-color: #fff;
    border-bottom: 1px solid #d8dee7;
    margin: 10px 0px;
    padding: 0 10px;
  }

  .question-preText {
    padding: 20px 0;
    border-bottom: 1px solid #f0f0f4;
    text-align: justify;
    text-justify: unset;
    padding: 10px;
    line-height: normal;
  }

  .question-endText {
    padding-bottom: 20px;
    text-align: center;
  }
}

.submit-container {
  margin-bottom: 50px;
  // padding: 10px;
  height: 50px;
  // position: fixed;
  // bottom: 0px;
  width: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  background: #fff;

  .el-button--primary {
    color: #fff;
    background-color: #2cc7c5;
    border-color: #2cc7c5;
  }

  .el-button--primary.is-active, .el-button--primary:active {
    background: #2cc7c5;
    border-color: #2cc7c5;
    color: #FFF;
  }

  .el-button--primary:focus, .el-button--primary:hover {
    background: #2cc7c5;
    border-color: #2cc7c5;
    color: #FFF;
  }

  .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
    background-color: #69cecc;
    border-color: #69cecc;
  }
}

.el-progress-bar__outer, .el-progress-bar__inner {
  border-radius: 0px !important;
}
</style>
